// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class TempGetNumberOfApplicationsDefaultResponseData {
    static getAttributeTypeMap() {
        return TempGetNumberOfApplicationsDefaultResponseData.attributeTypeMap;
    }
}
TempGetNumberOfApplicationsDefaultResponseData.discriminator = undefined;
TempGetNumberOfApplicationsDefaultResponseData.additionalProperties = false;
TempGetNumberOfApplicationsDefaultResponseData.attributeTypeMap = [
    {
        "name": "total",
        "baseName": "total",
        "type": "number"
    },
];
//# sourceMappingURL=tempGetNumberOfApplicationsDefaultResponseData.js.map